import { BaseHTMLElement, customElement, onEvent } from 'dom-native';

import { icon } from '@/utils/icons';

@customElement('help-agent-header')
export class HelpAgentHeader extends BaseHTMLElement {
  private _expanded = false;

  init(): void {
    super.init();
    this.render();
  }

  setExpanded(isExpanded: boolean): void {
    this._expanded = isExpanded;
    if (this.initialized) {
      this.render();
    }
  }

  private render(): void {
    const expandLabel = this._expanded ? 'Collapse help center' : 'Expand help center';
    const expandTitle = this._expanded ? 'Collapse' : 'Expand';

    this.innerHTML = `
      <div class="help-agent-header-shell" data-test="help-widget-header-shell">
        <div class="help-agent-header-main" data-test="help-widget-header-main">
          <div class="help-agent-header-brand" data-test="help-widget-header-brand">
            <span class="help-agent-header-logo">${icon('help-center-stars', {
              width: 'var(--ha-header-logo-width)',
              height: 'var(--ha-header-logo-height)',
            })}</span>
            <h1 class="help-agent-header-title">Enlil Help Center</h1>
          </div>
          <button
            type="button"
            class="help-agent-header-new"
            data-action="new-chat"
            data-test="help-widget-new-chat"
            aria-label="Start a new chat"
          >
            <span class="help-agent-header-new-icon">${icon('add', { size: 'var(--ha-header-new-icon-size)' })}</span>
            <span>New</span>
          </button>
        </div>
        <div class="help-agent-header-actions" data-test="help-widget-header-actions">
          <button
            type="button"
            class="help-agent-header-action${this._expanded ? ' is-active' : ''}"
            data-action="toggle-expand"
            data-test="help-widget-expand"
            aria-label="${expandLabel}"
            aria-pressed="${this._expanded}"
            title="${expandTitle}"
          >
            ${icon('expand-corners', {
              width: 'var(--ha-header-expand-icon-width)',
              height: 'var(--ha-header-expand-icon-height)',
            })}
          </button>
          <button
            type="button"
            class="help-agent-header-action"
            data-action="close"
            data-test="help-widget-close"
            aria-label="Close help center"
            title="Close"
          >
            ${icon('close', {
              width: 'var(--ha-header-close-icon-width)',
              height: 'var(--ha-header-close-icon-height)',
            })}
          </button>
        </div>
      </div>
    `;
  }

  @onEvent('click', '[data-action="new-chat"]')
  onNewChat(): void {
    this.dispatchEvent(new CustomEvent('help-agent:new-chat-intent', { bubbles: true, composed: true }));
  }

  @onEvent('click', '[data-action="toggle-expand"]')
  onToggleExpand(): void {
    this.dispatchEvent(new CustomEvent('help-agent:toggle-expand', { bubbles: true, composed: true }));
  }

  @onEvent('click', '[data-action="close"]')
  onClose(): void {
    this.dispatchEvent(new CustomEvent('help-agent:close-intent', { bubbles: true, composed: true }));
  }
}
